export const calculateScrollAnchor = () => {
  const subnav = document.getElementById('subnav')
  if (!subnav) return

  const navelements = subnav?.getElementsByTagName('a')
  if (!navelements) return

  const header = document.getElementById('mainnav')
  if (!header) return

  const main = document.getElementsByTagName('main')[0]
  if (!main) return

  let currentLink = null

  Array.from(navelements).reverse().some((element) => {
    const target = element.getAttribute('href') ?? ''
    const anchor = target.startsWith('#') ? document.getElementById(target.substring(1)) : null

    // A link whose section is not on this page tells us nothing about where the
    // reader is. That is not an exotic case: a resource with a custom detail
    // component renders none of the panels the sub navigation is built from, and
    // a panel can be hidden by permissions at any time.
    if (!anchor) return false

    if (main.scrollTop >= anchor.offsetTop - header.offsetHeight - 25) {
      currentLink = element
      return true
    }

    return false
  })

  if (!currentLink) {
    currentLink = Array.from(navelements)[0]
  }

  if (currentLink) {
    if (!currentLink.classList.contains('active')) {
      subnav.querySelector('.active')?.classList.remove('active')
      currentLink.classList.add('active')
    }
  }

  // After updating the active link, notify and align subnav if available
  try {
    window.scrollSubnavToActive && window.scrollSubnavToActive()
  } catch (e) {}

  try {
    window.dispatchEvent(new CustomEvent('subnav:active-changed', { detail: { link: currentLink } }))
  } catch (e) {}
}
